var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockUI',{staticClass:"line"},[_c('div',{staticClass:"new-loading"},[_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }